import React, { useState } from 'react';
import { message, Button } from 'antd';
// import intl from 'react-intl-universal';
import { fetchCancelMemberCheck } from '@/api/guest';

interface IProps {
  text: string;
  wyuid: any;
  type?: 'primary' | 'default' | 'dashed' | 'link' | 'text' | 'ghost' | undefined;
  businessDate?: any; // 业务时间
  className?: string;
  onClick?: (params?: any) => void;
  [rest: string]: any; // 捕获所有其他属性
}

// 会员注销校验按钮
const Index = ($$: IProps) => {
  const { type = 'link', className, wyuid, businessDate, text, onClick, ...rest } = $$;

  const [loading, setLoading] = useState<boolean>(false);

  // 会员注销校验
  const memberCancelCheck = async () => {
    try {
      setLoading(true);
      const res: any = await fetchCancelMemberCheck({
        businessDate,
        wyuid,
      });
      setLoading(false);
      if (res?.data) return true;
      return false;
    } catch (error) {
      setLoading(false);
      // message.error(JSON.stringify(error));
      // return false;
      return true; // 如果接口报错就不知道是否注销 继续让用户操作
    }
  };

  const handleClick = async () => {
    // 没有网鱼id就是不做检验
    if (!wyuid) {
      if (onClick) onClick();
      return;
    }
    const isPass = await memberCancelCheck();
    if (!isPass) {
      message.warning('该用户已注销，信息不可查询');
      return;
    }
    if (onClick) onClick();
  };

  return (
    <Button
      type={type}
      loading={loading}
      onClick={() => handleClick()}
      className={className}
      {...rest}
    >
      {text}
    </Button>
  );
};

export default Index;
